module.exports = "../img/Sprite-Inputs-2.png";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/Sprite-Inputs-2.png
// module id = 38
// module chunks = 0